export default "__VITE_ASSET__CsZCg3Pa__"